/**
 * RadNeo™ Design System — Z-Index Tokens
 */

export const zIndex = {
  base: 0,
  content: 1,
  sticky: 100,
  header: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500,
  splash: 9999,
} as const;
